export default function isKey(data, key) {
  return Object.hasOwn(data, key);
}
